import React from "react";
import { TestContext } from "../../CommonUI/Testing/TestContext";
import { TextMergeConfiguration } from "../../rule-engine-core/TextMerge/TextMergeConfiguration";
import { UIHTMLDisplay } from "../../CommonUI/BuildlingBlocks/UIHTMLDisplay";
import { TextMergeTestResult } from "../../rule-engine-core/TextMerge/TextMergeTestResult";
import { TextMergeType } from "../../rule-engine-core/TextMerge/TextMergeType";

export const RenderTestResult = ({ definition }: { definition: TextMergeConfiguration }) => {
    const testContext = React.useContext(TestContext);
    const resultitem = testContext?.findItem(definition._id);

    if (!resultitem) {
        return <></>;
    }

    if (definition.type === TextMergeType.HTML) {
        return (
            <div>
                <UIHTMLDisplay html={resultitem!.result || ""} />
            </div>
        );
    } else {
        return (
            <code>
                <pre>{resultitem!.result}</pre>
            </code>
        );
    }
};

export const RenderTestResultWithFields = ({ definition }: { definition: TextMergeConfiguration }) => {
    const testContext = React.useContext(TestContext);
    const resultitem = testContext?.findItem(definition._id);

    if (!resultitem) {
        return <></>;
    }

    if (definition.type === TextMergeType.HTML) {
        return (
            <div>
                <UIHTMLDisplay html={(resultitem! as TextMergeTestResult).textWithFields || ""} />
            </div>
        );
    } else {
        return (
            <code>
                <pre>{(resultitem! as TextMergeTestResult).textWithFields}</pre>
            </code>
        );
    }

    return (
        <div>
            <UIHTMLDisplay html={(resultitem! as TextMergeTestResult).textWithFields || ""} />
        </div>
    );
};
